import './promo.css';
import promoImg from '../../img/shelter__hero-img.jpg'
import {Link} from "react-router-dom";

const Promo = () => {
    return (
        <section className="promo">
            <div className="container">
                <div className="promo__content">
                    <div className="promo__text">
                        <div className="promo__title">
                            AirLink - Сучасний метод доступу до укриття без перешкод.
                        </div>
                        <div className="promo__desc">
                            Повітряна тривога? Ваші двері до укриття вже відчинені для вашого захисту
                        </div>
                        <div className="promo__btn-wrapper">
                            {" "}
                            <Link to="Order" className="promo__btn pulse">Замовити</Link>
                        </div>
                    </div>
                    <div className="promo__img">
                        <img src={promoImg} alt="modern shelter"/>
                    </div>
                </div>
            </div>
            <hr className="horizontal-line" />

        </section>
    );
}

export default Promo;